import { render, staticRenderFns } from "./add-to-cart.vue?vue&type=template&id=5497cc08&scoped=true&"
import script from "./add-to-cart.vue?vue&type=script&lang=js&"
export * from "./add-to-cart.vue?vue&type=script&lang=js&"
import style0 from "./add-to-cart.vue?vue&type=style&index=0&id=5497cc08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5497cc08",
  null
  
)

export default component.exports